import { render, staticRenderFns } from "./UserGroupModal.vue?vue&type=template&id=354d7382"
import script from "./UserGroupModal.vue?vue&type=script&lang=js"
export * from "./UserGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports